import React from 'react';
import { Button } from '@mui/material';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';

import { buttonSizeSx, secondaryButtonSx } from 'theme/buttons';

export const OpenResumeButton: React.FC<{
  href?: string;
  onOpen?: () => void;
}> = ({ href, onOpen }) => (
  <Button
    component={href ? 'a' : 'button'}
    href={href}
    target={href ? '_blank' : undefined}
    rel={href ? 'noopener' : undefined}
    onClick={onOpen}
    variant="outlined"
    startIcon={<DescriptionOutlinedIcon />}
    sx={{ ...buttonSizeSx.md, ...secondaryButtonSx }}
  >
    Open resume
  </Button>
);
